import useCUCompositeJobStore from "@/store/useCUCompositeJobStore";

import ExpandableSection from "../../../../../components/job/ExpandableSection";

import CompliantRepair from "./CompliantRepair";
import NonCompliantRepair from "./NonCompliantRepair";

const cardName = "checksSection";
export function Checks() {
  const { sections, toggleExpandableSection } = useCUCompositeJobStore();
  const savedChecksSection = sections.checksSection;
  const savedCompliantChecks = sections.complianceChecks;

  const isNonCompliantRecommended =
    savedCompliantChecks.data.desired_layer_count_options.length > 0 &&
    !savedCompliantChecks.data.desired_layer_count_options.includes("none");

  return (
    <ExpandableSection
      status={savedChecksSection.status}
      setIsExpanded={() => toggleExpandableSection(cardName)}
      title="Checks"
    >
      {/*one input*/}
      {isNonCompliantRecommended && <NonCompliantRepair />}
      {/*with yes no question*/}
      {!isNonCompliantRecommended && <CompliantRepair />}
    </ExpandableSection>
  );
}
